import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Guard funcional que valida que exista una sesión activa
 * Si no hay token en localStorage redirige a la pantalla de autenticación
 * @returns true si el usuario tiene sesión, de lo contrario false
 * @author Sistema Kobra
 */
export const authGuard: CanActivateFn = (): boolean => {
  const router: Router = inject(Router);

  let loggedIn: boolean = false;

  if (localStorage.getItem('access-token')) {
    loggedIn = true;
  } else {
    router.navigate(['/auth']);
  }

  return loggedIn;
};
